const localeStorageKey = 'locale';

class LocaleConfig {

    private actualLocale: string;

    constructor() {
        const actualStorageLocale = localStorage.getItem(localeStorageKey);
        if (actualStorageLocale) {
            this.ActualLocale = actualStorageLocale;
        } else {
            this.ActualLocale = 'en-US';
        }
    }

    set ActualLocale(locale: string) {
        localStorage.setItem(localeStorageKey, locale);
        this.actualLocale = locale;
    }

    get ActualLocale() {
        return this.actualLocale;
    }
}

export const localConfig = new LocaleConfig();
